// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:49:57

export default {
  "id": "drawing-squares",
  "slug": "drawing-squares",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ef72f0abe10f47189a45475ea815840c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ef72f0abe10f47189a45475ea815840c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Drawing Squares",
      "description": "Drawing Squares is the logic game that will blow your mind!\nIt is a logic game inspired by the classic pen and paper game Dots and Boxes. Do you remember the game you used to play at school? (also known as Boxes, Squares, Paddocks, Pigs in a Pen, Square-it, Dots and Dashes, Dots, Smart Dots, Dot Boxing, or, simply, the Dot Game).",
      "instructions": "The point of the game is, to complete a square on the graph paper on your classmate behalf. To do this you must draw a line where your classmate WILL NOT take advantage of your move and complete a square. The game ends when no more lines can be placed. The winner is the one who scores the most points.",
      "genres": [
        "Boardgames"
      ],
      "tags": [
        "board",
        "logic",
        "math",
        "school",
        "thinking"
      ]
    },
    "zh-CN": {
      "title": "画正方形",
      "description": "《画方》是一款能让你惊叹的逻辑游戏！这是一款受经典笔和纸游戏“点与框”启发的逻辑游戏。你还记得你在学校里玩过的那个游戏吗？（也称为框、方格、围场、圈猪、平方、点与破折号、点、智能点、点拳击、或者简单地，点游戏）。",
      "instructions": "游戏的目标是在图纸上代表你的同学完成一个正方形。为此，你必须画一条线，你的同学不会利用你的这一步来完成正方形。当不能再放置线条时，游戏结束。得分最多的人获胜。",
      "genres": [
        "桌游"
      ],
      "tags": [
        "棋盘",
        "逻辑",
        "数学",
        "学校",
        "思考"
      ]
    },
    "zh-TW": {
      "title": "畫方格",
      "description": "畫方格是一款會讓你驚嘆的邏輯遊戲！\n這是一款受到經典的筆和紙遊戲點線格啟發的邏輯遊戲。你還記得你在學校時玩的遊戲嗎？（也稱為方框、方格、牧場、圍圈豬、Square-it、點線、點、智慧點、點拳、或簡單來說，點遊戲）。",
      "instructions": "遊戲的目的是，為你的同學在圖紙上完成一個正方形。為此，你必须畫出線條，讓你的同學無法利用你的移動來完成正方形。遊戲結束當無法再放置更多線條時。獲勝者是得分最高的人。",
      "genres": [
        "桌遊"
      ],
      "tags": [
        "棋盤",
        "邏輯",
        "數學",
        "學校",
        "思考"
      ]
    },
    "zh-HK": {
      "title": "畫方格",
      "description": "畫方形是一個會驚嘆你腦海的邏輯遊戲！\n這是一款受到經典筆和紙遊戲「點與框」啟發的邏輯遊戲。你還記得在學校玩的那款遊戲嗎？（也稱為框、方形、牧場、圍籬內的豬、Square-it、點與點、點、智能點、點拳、或簡單來說，點遊戲）。",
      "instructions": "遊戲的目的是為你的同學代畫在圖紙上完成一個正方形。為了達到這個目的，你必須畫出一條線，這條線讓你的同學無法利用你的移動來完成正方形。當無法再放置更多線時，遊戲結束。獲分最多的一方為勝者。",
      "genres": [
        "桌遊"
      ],
      "tags": [
        "棋盤",
        "邏輯",
        "數學",
        "學校",
        "思考"
      ]
    },
    "ja": {
      "title": "四角形を描く",
      "description": "四角を描くのは、あなたの心を驚かせる論理ゲームです！これは、伝統的な筆と紙のゲーム、ドットとボックスにインスパイアされた論理ゲームです。学校で遊んでいたゲームを覚えていますか？（ボックス、四角、牧草地、猪小屋、Square-it、ドットとダッシュ、ドット、スマートドット、ドットボクシング、または単にドットゲームとも呼ばれます）。",
      "instructions": "ゲームの目的は、クラスメートの代わりにグラフ紙に四角形を完成させることです。これには、クラスメートがあなたの行動を利用して四角形を完成させないように、線を引く必要があります。線を置ける場所がなくなるとゲーム終了です。最もポイントを獲得した人が勝者です。",
      "genres": [
        "ボードゲーム"
      ],
      "tags": [
        "ボード",
        "ロジック",
        "数学",
        "学校",
        "思考"
      ]
    },
    "ko": {
      "title": "사각형 그리기",
      "description": "사각형 그리기는 정신을 사로잡는 로직 게임입니다!\n이 게임은 클래식한 펜과 종이 게임인 점과 사각형(Dots and Boxes)을 영감으로 얻었습니다. 학교에서了一起 놀던 게임을 기억하시나요? (박스, 사각형, 패드존, 펜에 고슴도치, 스퀘어잇, 점과 띠, 점, 스마트 점, 점 박싱, 또는 간단히 점 게임이라고도 합니다).",
      "instructions": "게임의 목적은, 그래프지에 친구 대신 사각형을 완성하는 것입니다. 이를 위해 친구가 당신의 움직임을 이용하지 않도록 사각형을 완성할 수 있는 선을 그려야 합니다. 선을 더 이상 배치할 수 없을 때 게임이 끝납니다. 점수를 가장 많이 획득한 사람이 승자입니다.",
      "genres": [
        "보드게임"
      ],
      "tags": [
        "보드",
        "로직",
        "수학",
        "학교",
        "사고력"
      ]
    },
    "fr": {
      "title": "Dessiner des Carrés",
      "description": "Drawing Squares est le jeu de logique qui vous bluffera !\n\nIl s'agit d'un jeu de logique inspiré du classique jeu de feutre et de papier Points et Carrés. Souvenez-vous du jeu que vous jouiez à l'école ? (connu également sous les noms de Boîtes, Carrés, Prairies, Porcs dans un Enclos, Square-it, Points et Coupes, Points, Smart Dots, Dot Boxing ou, simplement, le Jeu des Points).",
      "instructions": "L'objectif du jeu est de complêter un carré sur le papier graphique à la place de ton camarade. Pour cela, tu dois tracer une ligne où ton camarade NE PEUT PAS profiter de ton coup pour complêter un carré. Le jeu se termine lorsque plus aucune ligne ne peut être placée. Le gagnant est celui qui obtient le plus de points.",
      "genres": [
        "Jeux de plateau"
      ],
      "tags": [
        "grille",
        "logique",
        "mathématiques",
        "école",
        "réflexion"
      ]
    }
  }
};
